import { StreamController } from "webrtc-player/webrtc_controller/stream_controller";
import {
  useState,
  useRef,
  useEffect,
  useContext,
  memo,
  forwardRef,
} from "react";
import { SignalContext } from "context/SignalContext";
import clsx from "clsx";
import {
  SvgPeople,
  SvgAlertVehicleType,
  SvgAlertNonMotorVehicleType,
  SvgLogo,
  SvgSnapshotRefresh,
} from "ui/svgs";
import type { SnapshotDataTypes } from "pages/service";
import { STREAM_TYPE_LIVE } from "webrtc-player/common/base";
import { WebRTC } from "webrtc-player/webrtc/webrtc";
import { CameraAlertRegion } from "lib/types";
import { personKey, vehicleKey, onMotorVehicleKey } from "lib/constants";
import RegionRuleDraw from "ui/automation/region-rule-draw";
import CrowwLinesDraw from "ui/automation/cross-line-draw";
import { useCommonService } from "pages/service";
const TEN_THOUSAND = 10000;

const streamingOrSnapshot = 1; // 0: streaming, 1: snapshot
const CameraRuleEditPlayer = forwardRef(function CameraRuleEditPlayer(
  props: {
    type: string;
    cameraId: string;
    streamingCamera: any;
    supportedEventTypes: string[];
    intrusionDetection?: CameraAlertRegion;
    crossLineDetection?: { region: CameraAlertRegion; index: number }[];
    minPersonDetSize: number;
    minVehicleDetSize: number;
    minMotorVehicleDetSize: number;
    ruleIndex: number;
    objectSizeEnable: boolean;
    snapshot: SnapshotDataTypes;
    updateRegionDetection?: (points: { x: number; y: number }[]) => void;
    updateCrossLineDetection?: (pointers: { x: number; y: number }[]) => void;
  },
  ref,
) {
  const {
    type,
    cameraId,
    streamingCamera,
    intrusionDetection,
    crossLineDetection,
    supportedEventTypes,
    minPersonDetSize,
    minVehicleDetSize,
    minMotorVehicleDetSize,
    ruleIndex,
    objectSizeEnable,
    updateRegionDetection,
    updateCrossLineDetection,
    snapshot,
  } = props;
  const CANVAS_ID_PREFIX = "canvas_rule_edit_" + type + "_";
  const refContainer = useRef<HTMLDivElement>(null);
  const refVideo = useRef<HTMLVideoElement>(null);
  const refAudio = useRef(null);

  const refCanvasWrapper = useRef<HTMLDivElement>(null);

  // const [streamController, setStreamController] = useState<StreamController>();
  // const { signal, wsIsOpen } = useContext(SignalContext);

  const [canvasWidth, setCanvasWidth] = useState(0);
  const [canvasHeight, setCanvasHeight] = useState(0);
  const [canvasRatio, setCanvasRatio] = useState(0);
  const [canvasOffsetTop, setCanvasOffsetTop] = useState(0);
  const [canvasOffsetLeft, setCanvasLeft] = useState(0);

  // useEffect(() => {
  //   //@ts-expect-error
  //   if (signal && wsIsOpen && cameraId && streamingOrSnapshot === 0) {
  //     closeStreaming();
  //     playVideo();
  //   }
  // }, [signal, wsIsOpen, cameraId]);

  // function playVideo() {
  //   const token = streamingCamera.token;
  //   const turn = streamingCamera.turn;
  //   const rtcToken = streamingCamera.rtcToken;
  //   const sessionId = streamingCamera.sessionId;
  //   const orgId: number = +streamingCamera.orgId;
  //   const nvrId: number = +streamingCamera.nvrId;
  //   const cameraMac = streamingCamera.cameraMac;
  //   const remoteIndex = streamingCamera.remoteIndex;
  //   const streamId = streamingCamera.streamId;

  //   const video = refVideo.current;
  //   const audio = refAudio.current;
  //   const canvas = getCanvas();

  //   const streamParams = { cameraMac, remoteIndex, streamId: streamId };

  //   console.log("creating streamcontroller -> signal = ", signal, nvrId);

  //   const createdstreamController = new StreamController(
  //     {
  //       orgId,
  //       nvrId,
  //       signal,
  //       turn,
  //       rtcToken,
  //       debugging: Boolean(ENV === "development"),
  //     },
  //     {
  //       streamParams: streamParams,
  //       streamType: STREAM_TYPE_LIVE,
  //       video,
  //       audio,
  //       canvas,
  //     },
  //   );

  //   createdstreamController.webRTC.addEventListener(
  //     WebRTC.EVENT_MESSAGE_OPEN,
  //     (channel: RTCDataChannel) => {
  //       const canvas = document.getElementById(
  //         CANVAS_ID_PREFIX + streamingCamera.cameraId,
  //       ) as HTMLCanvasElement;
  //       setCanvasRatio(canvas.width / canvas.height);
  //       console.log("get canvas Ratio:", canvas.width / canvas.height);

  //       resizeChange();
  //     },
  //   );

  //   createdstreamController.start(); ///+++
  //   setStreamController(createdstreamController);
  //   return createdstreamController;
  // }

  useEffect(() => {
    //@ts-expect-error
    if (streamingOrSnapshot === 0) {
      return;
    }
    // Fill canvas
    if (snapshot?.width > 0) {
      setCanvasRatio(snapshot?.width / snapshot.height);
    }
  }, [snapshot]);

  // useEffect(() => {
  //   //@ts-expect-error
  //   if (streamingOrSnapshot === 0) {
  //     return;
  //   }
  //   setIndexDBPicData(null);
  //   db.read(DB_STORE.SNAPSHOT, +streamingCamera.cameraId).then(
  //     (data: DbPicDataType) => {
  //       console.log("Read data", data);
  //       if (!data) {
  //         setIndexDBPicData(null);
  //         return;
  //       }
  //       setIndexDBPicData(data);
  //       if (data.width && data.height) {
  //         setCanvasRatio(data.width / data.height);
  //         resizeChange();
  //       }

  //       console.log("Read data", data);
  //     },
  //   );
  // }, [streamingCamera]);

  // function getCanvas() {
  //   //refCanvasWrapper.current.innerHTML = '';
  //   const canvas = document.createElement("canvas");
  //   canvas.className = "canvas w-full h-full max-w-full max-h-full";
  //   canvas.id = CANVAS_ID_PREFIX + streamingCamera.cameraId;
  //   //refCanvasWrapper.current.removeChild(refCanvasWrapper.current.lastChild);
  //   refCanvasWrapper.current.appendChild(canvas);
  //   return canvas;
  // }

  // function closeStreaming() {
  //   if (streamController) {
  //     console.log("realyly closeStreaming");
  //     streamController.close();
  //   }
  // }

  // useEffect(() => {
  //   return () => {
  //     closeStreaming();
  //   };
  // }, [streamController]);

  useEffect(() => {
    return () => {
      if (streamingOrSnapshot === 1) {
        return;
      }
      const canvas = document.getElementById(CANVAS_ID_PREFIX + cameraId);
      if (refCanvasWrapper && refCanvasWrapper.current && canvas) {
        refCanvasWrapper.current.removeChild(canvas);
      }
    };
  }, [cameraId]);

  function resizeChange() {
    const canvas = document.getElementById(
      CANVAS_ID_PREFIX + streamingCamera.cameraId,
    ) as HTMLCanvasElement;
    if (!refCanvasWrapper.current || !canvas || !canvasRatio) {
      return;
    }

    console.log(
      "get canvas wrapper ",
      refCanvasWrapper.current.getBoundingClientRect(),
      canvasRatio,
    );
    const wrapperRect = refCanvasWrapper.current.getBoundingClientRect();
    if (wrapperRect.width / wrapperRect.height > canvasRatio) {
      setCanvasWidth(Math.floor(wrapperRect.height * canvasRatio));
      setCanvasHeight(Math.floor(wrapperRect.height));
      setCanvasOffsetTop(0);
      setCanvasLeft((wrapperRect.width - wrapperRect.height * canvasRatio) / 2);
      canvas.style.width = wrapperRect.height * canvasRatio + "px";
      canvas.style.height = wrapperRect.height + "px";
      canvas.style.marginLeft =
        (wrapperRect.width - wrapperRect.height * canvasRatio) / 2 + " px";
    } else {
      setCanvasHeight(Math.floor(wrapperRect.width / canvasRatio));
      setCanvasWidth(Math.floor(wrapperRect.width));
      setCanvasLeft(0);
      setCanvasOffsetTop(
        (wrapperRect.height - wrapperRect.width / canvasRatio) / 2,
      );
      canvas.style.width = wrapperRect.width + "px";
      canvas.style.height = wrapperRect.width / canvasRatio + "px";
      canvas.style.marginTop =
        (wrapperRect.height - wrapperRect.width / canvasRatio) / 2 + " px";
    }
  }

  // useEffect(() => {
  //   if (!snapshot) {
  //     return;
  //   }
  //   resizeChange();
  // }, [canvasRatio, streamingCamera]);

  useEffect(() => {
    if (!snapshot) {
      return;
    }
    resizeChange();
    window.addEventListener("resize", resizeChange, false);
    return () => window.removeEventListener("resize", resizeChange); // clean up
  }, [canvasRatio, streamingCamera, snapshot]);

  const getSnapshotContent = () => {
    if (streamingOrSnapshot !== 1) {
      return null;
    }
    console.log("lllsnapshot", snapshot);
    return (
      <div
        className="w-full h-full flex items-center justify-center "
        id={CANVAS_ID_PREFIX + streamingCamera.cameraId}
      >
        {snapshot?.blob && (
          <img
            src={URL.createObjectURL(snapshot?.blob)}
            alt="Camera Placeholder"
            className="object-contain w-full h-full max-w-full max-h-full"
            //className="aspect-video"
            // id={CANVAS_ID_PREFIX + streamingCamera.cameraId}
          />
        )}

        <SvgLogo width="28" className="fill-zinc-400 mb-3" />
      </div>
    );
  };

  return (
    <>
      <div
        className={clsx(
          "w-full relative overflow-hidden group border-transparent flex justify-center",
        )}
        ref={refContainer}
      >
        <video id="video" ref={refVideo} className="hidden" />
        <div
          ref={refCanvasWrapper}
          className="bg-transparent flex justify-center relative w-full items-center aspect-video bg-zinc-100"
          id="canvasWrapper"
        >
          {getSnapshotContent()}

          {objectSizeEnable && ruleIndex >= 0 && (
            <div
              className={`absolute flex justify-center items-center gap-5 `}
              style={{
                width: canvasWidth,
                height: canvasHeight,
                top: canvasOffsetTop,
                left: canvasOffsetLeft,
              }}
            >
              {supportedEventTypes.includes(personKey) && (
                <div className="border border-dashed p-0.5">
                  <SvgPeople
                    width={(minPersonDetSize * canvasWidth) / TEN_THOUSAND}
                    className="fill-white"
                  />
                </div>
              )}
              {supportedEventTypes.includes(vehicleKey) && (
                <div className="border border-dashed p-0.5">
                  <SvgAlertVehicleType
                    className="fill-white"
                    width={(minVehicleDetSize * canvasWidth) / TEN_THOUSAND}
                  />
                </div>
              )}
              {supportedEventTypes.includes(onMotorVehicleKey) && (
                <div className="border border-dashed p-0.5">
                  <SvgAlertNonMotorVehicleType
                    width={
                      (minMotorVehicleDetSize * canvasWidth) / TEN_THOUSAND
                    }
                    className="fill-white"
                  />
                </div>
              )}
            </div>
          )}
          {type === "regions" && ruleIndex >= 0 && (
            <RegionRuleDraw
              regionDetection={intrusionDetection}
              ruleIndex={ruleIndex}
              updateRegionDetection={(points) => updateRegionDetection(points)}
              canvasProps={{
                canvasWidth: canvasWidth,
                canvasHeight: canvasHeight,
                canvasOffsetTop: canvasOffsetTop,
                canvasOffsetLeft: canvasOffsetLeft,
              }}
            />
          )}
          {type === "cross-line" &&
            crossLineDetection?.map((crossLine) => (
              <CrowwLinesDraw
                key={crossLine.index}
                corssLine={crossLine.region}
                ruleIndex={crossLine.index}
                selected={ruleIndex === crossLine.index}
                updateCrossLineDetection={(pointers) =>
                  updateCrossLineDetection(pointers)
                }
                canvasProps={{
                  canvasWidth: canvasWidth,
                  canvasHeight: canvasHeight,
                  canvasOffsetTop: canvasOffsetTop,
                  canvasOffsetLeft: canvasOffsetLeft,
                }}
              />
            ))}
        </div>

        <audio id="audio" ref={refAudio}></audio>
      </div>
    </>
  );
});

export default memo(CameraRuleEditPlayer);
// export default CameraRuleEditPlayer;
